import React from 'react';
import { MagazineAuthorText } from '../styles';
var MagazineAuthor = function (_a) {
    var post = _a.post;
    return React.createElement(MagazineAuthorText, null, post.text);
};
export default MagazineAuthor;
//# sourceMappingURL=MagazineAuthor.js.mapimport React from 'react';
import { MagazineAuthorText } from '../styles';
var MagazineAuthor = function (_a) {
    var post = _a.post;
    return React.createElement(MagazineAuthorText, null, post.text);
};
export default MagazineAuthor;
//# sourceMappingURL=MagazineAuthor.js.map